(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["layered-slideshow"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function initLayeredSlideshowNav(section) {
      const prevBtn = section.querySelector('.layered-slideshow__nav-prev');
      const nextBtn = section.querySelector('.layered-slideshow__nav-next');
      const tablist = section.querySelector('.layered-slideshow__tablist');

      if (!prevBtn || !nextBtn || !tablist) return;

      function getTabs() {
        return Array.from(tablist.querySelectorAll('[role="tab"]'));
      }

      function getActiveIndex(tabs) {
        return tabs.findIndex(t => t.getAttribute('aria-selected') === 'true');
      }

      function goToSlide(index) {
        const tabs = getTabs();
        if (!tabs.length) return;
        const total = tabs.length;
        const target = tabs[((index % total) + total) % total];
        if (!target) return;

        // 更新 aria-selected 和 tabindex
        tabs.forEach((tab, i) => {
          const isActive = i === (((index % total) + total) % total);
          tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
          tab.setAttribute('tabindex', isActive ? '0' : '-1');
        });

        // 触发 focus + click，兼容 layered-slideshow-component 内部逻辑
        target.focus({ preventScroll: true });
        target.click();
        target.dispatchEvent(new Event('change', { bubbles: true }));
      }

      prevBtn.addEventListener('click', function() {
        const tabs = getTabs();
        const current = getActiveIndex(tabs);
        goToSlide(current - 1);
      });

      nextBtn.addEventListener('click', function() {
        const tabs = getTabs();
        const current = getActiveIndex(tabs);
        goToSlide(current + 1);
      });
    }

    function init() {
      document.querySelectorAll('.layered-slideshow-section').forEach(function(section) {
        // 等待 layered-slideshow-component 自定义元素升级完成
        const component = section.querySelector('layered-slideshow-component');
        if (component && typeof component.connectedCallback === 'function') {
          initLayeredSlideshowNav(section);
        } else {
          // 用 MutationObserver 等待组件就绪
          const observer = new MutationObserver(function() {
            initLayeredSlideshowNav(section);
            observer.disconnect();
          });
          observer.observe(section, { childList: true, subtree: true, attributes: true });
          // 兜底：直接初始化
          initLayeredSlideshowNav(section);
        }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
